import styled from 'styled-components';
import { ButtonBlock } from 'components/theme/Button/Button';

export const NotFoundWrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  & a {
    padding-left: 20px;
    padding-right: 20px;
    margin-bottom: 20px;
  }
`;

export const ViewAllExperiencesButton = styled(ButtonBlock)`
  && {
    width: fit-content;
    color: var(--way-colors-buttonColorContrastShades-80);
    &:hover {
      color: var(--way-colors-buttonColorContrastShades-100);
    }
  }
`;

export const NotFoundTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: var(--way-colors-primaryTextColor);
  margin-bottom: 8px;
  text-align: center;
`;

export const NotFoundSubtitle = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: var(--way-colors-tertiaryTextColor);
  margin-bottom: 24px;
  text-align: center;
  max-width: 400px;
`;
